/*!
 * jQuery UI Draggable 1.10.3
 * http://jqueryui.com
 *
 * Copyright 2013 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/draggable/
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
(function($, undefined) {
  $.widget('ui.draggable', $.ui.mouse, {
    version: '1.10.3',
    widgetEventPrefix: 'drag',
    options: {
      addClasses: true,
      appendTo: 'parent',
      axis: false,
      connectToSortable: false,
      containment: false,
      cursor: 'auto',
      cursorAt: false,
      grid: false,
      handle: false,
      helper: 'original',
      iframeFix: false,
      opacity: false,
      refreshPositions: false,
      revert: false,
      revertDuration: 500,
      scope: 'default',
      scroll: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      snap: false,
      snapMode: 'both',
      snapTolerance: 20,
      stack: false,
      zIndex: false,

      // callbacks
      drag: null,
      start: null,
      stop: null,
    },
    _create: function() {
      if (
        this.options.helper === 'original' &&
        !/^(?:r|a|f)/.test(this.element.css('position'))
      ) {
        this.element[0].style.position = 'relative';
      }
      if (this.options.addClasses) {
        this.element.addClass('ui-draggable');
      }
      if (this.options.disabled) {
        this.element.addClass('ui-draggable-disabled');
      }

      this._mouseInit();
    },

    _destroy: function() {
      this.element.removeClass(
        'ui-draggable ui-draggable-dragging ui-draggable-disabled',
      );
      this._mouseDestroy();
    },

    _mouseCapture: function(event) {
      var o = this.options;

      // among others, prevent a drag on a resizable-handle
      if (
        this.helper ||
        o.disabled ||
        $(event.target).closest('.ui-resizable-handle').length > 0
      ) {
        return false;
      }

      //Quit if we're not on a valid handle
      this.handle = this._getHandle(event);
      if (!this.handle) {
        return false;
      }

      $(o.iframeFix === true ? 'iframe' : o.iframeFix).each(function() {
        $(
          "<div class='ui-draggable-iframeFix' style='background: #fff;'></div>",
        )
          .css({
            width: this.offsetWidth + 'px',
            height: this.offsetHeight + 'px',
            position: 'absolute',
            opacity: '0.001',
            zIndex: 1000,
          })
          .css($(this).offset())
          .appendTo('body');
      });

      return true;
    },

    _mouseStart: function(event) {
      var o = this.options;

      //Create and append the visible helper
      this.helper = this._createHelper(event);

      this.helper.addClass('ui-draggable-dragging');

      //Cache the helper size
      this._cacheHelperProportions();

      //If ddmanager is used for droppables, set the global draggable
      if ($.ui.ddmanager) {
        $.ui.ddmanager.current = this;
      }

      /*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

      //Cache the margins of the original element
      this._cacheMargins();

      //Store the helper's css position
      this.cssPosition = this.helper.css('position');
      this.scrollParent = this.helper.scrollParent();
      this.offsetParent = this.helper.offsetParent();
      this.offsetParentCssPosition = this.offsetParent.css('position');

      //The element's absolute position on the page minus margins
      this.offset = this.positionAbs = this.element.offset();
      this.offset = {
        top: this.offset.top - this.margins.top,
        left: this.offset.left - this.margins.left,
      };

      //Reset scroll cache
      this.offset.scroll = false;

      $.extend(this.offset, {
        click: {
          //Where the click happened, relative to the element
          left: event.pageX - this.offset.left,
          top: event.pageY - this.offset.top,
        },
        parent: this._getParentOffset(),
        relative: this._getRelativeOffset(), //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
      });

      //Generate the original position
      this.originalPosition = this.position = this._generatePosition(event);
      this.originalPageX = event.pageX;
      this.originalPageY = event.pageY;

      //Adjust the mouse offset relative to the helper if "cursorAt" is supplied
      o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt);

      //Set a containment if given in the options
      this._setContainment();

      //Trigger event + callbacks
      if (this._trigger('start', event) === false) {
        this._clear();
        return false;
      }

      //Recache the helper size
      this._cacheHelperProportions();

      //Prepare the droppable offsets
      if ($.ui.ddmanager && !o.dropBehaviour) {
        $.ui.ddmanager.prepareOffsets(this, event);
      }

      this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position

      //If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
      if ($.ui.ddmanager) {
        $.ui.ddmanager.dragStart(this, event);
      }

      return true;
    },

    _mouseDrag: function(event, noPropagation) {
      // reset any necessary cached properties (see #5009)
      if (this.offsetParentCssPosition === 'fixed') {
        this.offset.parent = this._getParentOffset();
      }

      //Compute the helpers position
      this.position = this._generatePosition(event);
      this.positionAbs = this._convertPositionTo('absolute');

      //Call plugins and callbacks and use the resulting position if something is returned
      if (!noPropagation) {
        var ui = this._uiHash();
        if (this._trigger('drag', event, ui) === false) {
          this._mouseUp({});
          return false;
        }
        this.position = ui.position;
      }

      if (!this.options.axis || this.options.axis !== 'y') {
        this.helper[0].style.left = this.position.left + 'px';
      }
      if (!this.options.axis || this.options.axis !== 'x') {
        this.helper[0].style.top = this.position.top + 'px';
      }
      if ($.ui.ddmanager) {
        $.ui.ddmanager.drag(this, event);
      }

      return false;
    },

    _mouseStop: function(event) {
      //If we are using droppables, inform the manager about the drop
      var that = this,
        dropped = false;
      if ($.ui.ddmanager && !this.options.dropBehaviour) {
        dropped = $.ui.ddmanager.drop(this, event);
      }

      //if a drop comes from outside (a sortable)
      if (this.dropped) {
        dropped = this.dropped;
        this.dropped = false;
      }

      //if the original element is no longer in the DOM don't bother to continue (see #8269)
      if (
        this.options.helper === 'original' &&
        !$.contains(this.element[0].ownerDocument, this.element[0])
      ) {
        return false;
      }

      if (
        (this.options.revert === 'invalid' && !dropped) ||
        (this.options.revert === 'valid' && dropped) ||
        this.options.revert === true ||
        ($.isFunction(this.options.revert) &&
          this.options.revert.call(this.element, dropped))
      ) {
        $(this.helper).animate(
          this.originalPosition,
          parseInt(this.options.revertDuration, 10),
          function() {
            if (that._trigger('stop', event) !== false) {
              that._clear();
            }
          },
        );
      } else {
        if (this._trigger('stop', event) !== false) {
          this._clear();
        }
      }

      return false;
    },

    _mouseUp: function(event) {
      //Remove frame helpers
      $('div.ui-draggable-iframeFix').each(function() {
        this.parentNode.removeChild(this);
      });

      //If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
      if ($.ui.ddmanager) {
        $.ui.ddmanager.dragStop(this, event);
      }

      return $.ui.mouse.prototype._mouseUp.call(this, event);
    },

    cancel: function() {
      if (this.helper.is('.ui-draggable-dragging')) {
        this._mouseUp({});
      } else {
        this._clear();
      }

      return this;
    },

    _getHandle: function(event) {
      return this.options.handle
        ? !!$(event.target).closest(this.element.find(this.options.handle))
            .length
        : true;
    },

    _createHelper: function(event) {
      var o = this.options,
        helper = $.isFunction(o.helper)
          ? $(o.helper.apply(this.element[0], [event]))
          : o.helper === 'clone'
            ? this.element.clone().removeAttr('id')
            : this.element;

      if (!helper.parents('body').length) {
        helper.appendTo(
          o.appendTo === 'parent' ? this.element[0].parentNode : o.appendTo,
        );
      }

      if (
        helper[0] !== this.element[0] &&
        !/(fixed|absolute)/.test(helper.css('position'))
      ) {
        helper.css('position', 'absolute');
      }

      return helper;
    },

    _adjustOffsetFromHelper: function(obj) {
      if (typeof obj === 'string') {
        obj = obj.split(' ');
      }
      if ($.isArray(obj)) {
        obj = { left: +obj[0], top: +obj[1] || 0 };
      }
      if ('left' in obj) {
        this.offset.click.left = obj.left + this.margins.left;
      }
      if ('right' in obj) {
        this.offset.click.left =
          this.helperProportions.width - obj.right + this.margins.left;
      }
      if ('top' in obj) {
        this.offset.click.top = obj.top + this.margins.top;
      }
      if ('bottom' in obj) {
        this.offset.click.top =
          this.helperProportions.height - obj.bottom + this.margins.top;
      }
    },

    _getParentOffset: function() {
      //Get the offsetParent and cache its position
      var po = this.offsetParent.offset();

      // This is a special case where we need to modify a offset calculated on start, since the following happened:
      // 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
      // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
      //    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
      if (
        this.cssPosition === 'absolute' &&
        this.scrollParent[0] !== document &&
        $.contains(this.scrollParent[0], this.offsetParent[0])
      ) {
        po.left += this.scrollParent.scrollLeft();
        po.top += this.scrollParent.scrollTop();
      }

      //This needs to be actually done for all browsers, since pageX/pageY includes this information
      //Ugly IE fix
      if (
        this.offsetParent[0] === document.body ||
        (this.offsetParent[0].tagName &&
          this.offsetParent[0].tagName.toLowerCase() === 'html' &&
          $.ui.ie)
      ) {
        po = { top: 0, left: 0 };
      }

      return {
        top:
          po.top + (parseInt(this.offsetParent.css('borderTopWidth'), 10) || 0),
        left:
          po.left +
          (parseInt(this.offsetParent.css('borderLeftWidth'), 10) || 0),
      };
    },

    _getRelativeOffset: function() {
      if (this.cssPosition === 'relative') {
        var p = this.element.position();
        return {
          top:
            p.top -
            (parseInt(this.helper.css('top'), 10) || 0) +
            this.scrollParent.scrollTop(),
          left:
            p.left -
            (parseInt(this.helper.css('left'), 10) || 0) +
            this.scrollParent.scrollLeft(),
        };
      } else {
        return { top: 0, left: 0 };
      }
    },

    _cacheMargins: function() {
      this.margins = {
        left: parseInt(this.element.css('marginLeft'), 10) || 0,
        top: parseInt(this.element.css('marginTop'), 10) || 0,
        right: parseInt(this.element.css('marginRight'), 10) || 0,
        bottom: parseInt(this.element.css('marginBottom'), 10) || 0,
      };
    },

    _cacheHelperProportions: function() {
      this.helperProportions = {
        width: this.helper.outerWidth(),
        height: this.helper.outerHeight(),
      };
    },

    _setContainment: function() {
      var over,
        c,
        ce,
        o = this.options;

      if (!o.containment) {
        this.containment = null;
        return;
      }

      if (o.containment === 'window') {
        this.containment = [
          $(window).scrollLeft() -
            this.offset.relative.left -
            this.offset.parent.left,
          $(window).scrollTop() -
            this.offset.relative.top -
            this.offset.parent.top,
          $(window).scrollLeft() +
            $(window).width() -
            this.helperProportions.width -
            this.margins.left,
          $(window).scrollTop() +
            ($(window).height() || document.body.parentNode.scrollHeight) -
            this.helperProportions.height -
            this.margins.top,
        ];
        return;
      }

      if (o.containment === 'document') {
        this.containment = [
          0,
          0,
          $(document).width() -
            this.helperProportions.width -
            this.margins.left,
          ($(document).height() || document.body.parentNode.scrollHeight) -
            this.helperProportions.height -
            this.margins.top,
        ];
        return;
      }

      if (o.containment.constructor === Array) {
        this.containment = o.containment;
        return;
      }

      if (o.containment === 'parent') {
        o.containment = this.helper[0].parentNode;
      }

      c = $(o.containment);
      ce = c[0];

      if (!ce) {
        return;
      }

      over = c.css('overflow') !== 'hidden';

      this.containment = [
        (parseInt(c.css('borderLeftWidth'), 10) || 0) +
          (parseInt(c.css('paddingLeft'), 10) || 0),
        (parseInt(c.css('borderTopWidth'), 10) || 0) +
          (parseInt(c.css('paddingTop'), 10) || 0),
        (over ? Math.max(ce.scrollWidth, ce.offsetWidth) : ce.offsetWidth) -
          (parseInt(c.css('borderRightWidth'), 10) || 0) -
          (parseInt(c.css('paddingRight'), 10) || 0) -
          this.helperProportions.width -
          this.margins.left -
          this.margins.right,
        (over ? Math.max(ce.scrollHeight, ce.offsetHeight) : ce.offsetHeight) -
          (parseInt(c.css('borderBottomWidth'), 10) || 0) -
          (parseInt(c.css('paddingBottom'), 10) || 0) -
          this.helperProportions.height -
          this.margins.top -
          this.margins.bottom,
      ];
      this.relative_container = c;
    },

    _convertPositionTo: function(d, pos) {
      if (!pos) {
        pos = this.position;
      }

      var mod = d === 'absolute' ? 1 : -1,
        scroll =
          this.cssPosition === 'absolute' &&
          !(
            this.scrollParent[0] !== document &&
            $.contains(this.scrollParent[0], this.offsetParent[0])
          )
            ? this.offsetParent
            : this.scrollParent;

      //Cache the scroll
      if (!this.offset.scroll) {
        this.offset.scroll = {
          top: scroll.scrollTop(),
          left: scroll.scrollLeft(),
        };
      }

      return {
        top:
          pos.top + // The absolute mouse position
          this.offset.relative.top * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.top * mod - // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === 'fixed'
            ? -this.scrollParent.scrollTop()
            : this.offset.scroll.top) *
            mod,
        left:
          pos.left + // The absolute mouse position
          this.offset.relative.left * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.left * mod - // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === 'fixed'
            ? -this.scrollParent.scrollLeft()
            : this.offset.scroll.left) *
            mod,
      };
    },

    _generatePosition: function(event) {
      var containment,
        co,
        top,
        left,
        o = this.options,
        scroll =
          this.cssPosition === 'absolute' &&
          !(
            this.scrollParent[0] !== document &&
            $.contains(this.scrollParent[0], this.offsetParent[0])
          )
            ? this.offsetParent
            : this.scrollParent,
        pageX = event.pageX,
        pageY = event.pageY;

      //Cache the scroll
      if (!this.offset.scroll) {
        this.offset.scroll = {
          top: scroll.scrollTop(),
          left: scroll.scrollLeft(),
        };
      }

      /*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

      // If we are not dragging yet, we won't check for options
      if (this.originalPosition) {
        if (this.containment) {
          if (this.relative_container) {
            co = this.relative_container.offset();
            containment = [
              this.containment[0] + co.left,
              this.containment[1] + co.top,
              this.containment[2] + co.left,
              this.containment[3] + co.top,
            ];
          } else {
            containment = this.containment;
          }

          if (event.pageX - this.offset.click.left < containment[0]) {
            pageX = containment[0] + this.offset.click.left;
          }
          if (event.pageY - this.offset.click.top < containment[1]) {
            pageY = containment[1] + this.offset.click.top;
          }
          if (event.pageX - this.offset.click.left > containment[2]) {
            pageX = containment[2] + this.offset.click.left;
          }
          if (event.pageY - this.offset.click.top > containment[3]) {
            pageY = containment[3] + this.offset.click.top;
          }
        }

        if (o.grid) {
          //Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
          top = o.grid[1]
            ? this.originalPageY +
              Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1]
            : this.originalPageY;
          pageY = containment
            ? top - this.offset.click.top >= containment[1] ||
              top - this.offset.click.top > containment[3]
              ? top
              : top - this.offset.click.top >= containment[1]
                ? top - o.grid[1]
                : top + o.grid[1]
            : top;

          left = o.grid[0]
            ? this.originalPageX +
              Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0]
            : this.originalPageX;
          pageX = containment
            ? left - this.offset.click.left >= containment[0] ||
              left - this.offset.click.left > containment[2]
              ? left
              : left - this.offset.click.left >= containment[0]
                ? left - o.grid[0]
                : left + o.grid[0]
            : left;
        }
      }

      return {
        top:
          pageY - // The absolute mouse position
          this.offset.click.top - // Click offset (relative to the element)
          this.offset.relative.top - // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.top + // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === 'fixed'
            ? -this.scrollParent.scrollTop()
            : this.offset.scroll.top),
        left:
          pageX - // The absolute mouse position
          this.offset.click.left - // Click offset (relative to the element)
          this.offset.relative.left - // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.left + // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === 'fixed'
            ? -this.scrollParent.scrollLeft()
            : this.offset.scroll.left),
      };
    },

    _clear: function() {
      this.helper.removeClass('ui-draggable-dragging');
      if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
        this.helper.remove();
      }
      this.helper = null;
      this.cancelHelperRemoval = false;
    },

    // From now on bulk stuff - mainly helpers

    _trigger: function(type, event, ui) {
      ui = ui || this._uiHash();
      $.ui.plugin.call(this, type, [event, ui]);
      //The absolute position has to be recalculated after plugins
      if (type === 'drag') {
        this.positionAbs = this._convertPositionTo('absolute');
      }
      return $.Widget.prototype._trigger.call(this, type, event, ui);
    },

    plugins: {},

    _uiHash: function() {
      return {
        helper: this.helper,
        position: this.position,
        originalPosition: this.originalPosition,
        offset: this.positionAbs,
      };
    },
  });

  $.ui.plugin.add('draggable', 'connectToSortable', {
    start: function(event, ui) {
      var inst = $(this).data('ui-draggable'),
        o = inst.options,
        uiSortable = $.extend({}, ui, { item: inst.element });
      inst.sortables = [];
      $(o.connectToSortable).each(function() {
        var sortable = $.data(this, 'ui-sortable');
        if (sortable && !sortable.options.disabled) {
          inst.sortables.push({
            instance: sortable,
            shouldRevert: sortable.options.revert,
          });
          sortable.refreshPositions(); // Call the sortable's refreshPositions at drag start to refresh the containerCache since the sortable container cache is used in drag and needs to be up to date (this will ensure it's initialised as well as being kept in step with any changes that might have happened on the page).
          sortable._trigger('activate', event, uiSortable);
        }
      });
    },
    stop: function(event, ui) {
      //If we are still over the sortable, we fake the stop event of the sortable, but also remove helper
      var inst = $(this).data('ui-draggable'),
        uiSortable = $.extend({}, ui, { item: inst.element });

      $.each(inst.sortables, function() {
        if (this.instance.isOver) {
          this.instance.isOver = 0;

          inst.cancelHelperRemoval = true; //Don't remove the helper in the draggable instance
          this.instance.cancelHelperRemoval = false; //Remove it in the sortable instance (so sortable plugins like revert still work)

          //The sortable revert is supported, and we have to set a temporary dropped variable on the draggable to support revert: "valid/invalid"
          if (this.shouldRevert) {
            this.instance.options.revert = this.shouldRevert;
          }

          //Trigger the stop of the sortable
          this.instance._mouseStop(event);

          this.instance.options.helper = this.instance.options._helper;

          //If the helper has been the original item, restore properties in the sortable
          if (inst.options.helper === 'original') {
            this.instance.currentItem.css({ top: 'auto', left: 'auto' });
          }
        } else {
          this.instance.cancelHelperRemoval = false; //Remove the helper in the sortable instance
          this.instance._trigger('deactivate', event, uiSortable);
        }
      });
    },
    drag: function(event, ui) {
      var inst = $(this).data('ui-draggable'),
        that = this;

      $.each(inst.sortables, function() {
        var innermostIntersecting = false,
          thisSortable = this;

        //Copy over some variables to allow calling the sortable's native _intersectsWith
        this.instance.positionAbs = inst.positionAbs;
        this.instance.helperProportions = inst.helperProportions;
        this.instance.offset.click = inst.offset.click;

        if (this.instance._intersectsWith(this.instance.containerCache)) {
          innermostIntersecting = true;
          $.each(inst.sortables, function() {
            this.instance.positionAbs = inst.positionAbs;
            this.instance.helperProportions = inst.helperProportions;
            this.instance.offset.click = inst.offset.click;
            if (
              this !== thisSortable &&
              this.instance._intersectsWith(this.instance.containerCache) &&
              $.contains(
                thisSortable.instance.element[0],
                this.instance.element[0],
              )
            ) {
              innermostIntersecting = false;
            }
            return innermostIntersecting;
          });
        }

        if (innermostIntersecting) {
          //If it intersects, we use a little isOver variable and set it once, so our move-in stuff gets fired only once
          if (!this.instance.isOver) {
            this.instance.isOver = 1;
            //Now we fake the start of dragging for the sortable instance,
            //by cloning the list group item, appending it to the sortable and using it as inst.currentItem
            //We can then fire the start event of the sortable with our passed browser event, and our own helper (so it doesn't create a new one)
            this.instance.currentItem = $(that)
              .clone()
              .removeAttr('id')
              .appendTo(this.instance.element)
              .data('ui-sortable-item', true);
            this.instance.options._helper = this.instance.options.helper; //Store helper option to later restore it
            this.instance.options.helper = function() {
              return ui.helper[0];
            };

            event.target = this.instance.currentItem[0];
            this.instance._mouseCapture(event, true);
            this.instance._mouseStart(event, true, true);

            //Because the browser event is way off the new appended portlet, we modify a couple of variables to reflect the changes
            this.instance.offset.click.top = inst.offset.click.top;
            this.instance.offset.click.left = inst.offset.click.left;
            this.instance.offset.parent.left -=
              inst.offset.parent.left - this.instance.offset.parent.left;
            this.instance.offset.parent.top -=
              inst.offset.parent.top - this.instance.offset.parent.top;

            inst._trigger('toSortable', event);
            inst.dropped = this.instance.element; //draggable revert needs that
            //hack so receive/update callbacks work (mostly)
            inst.currentItem = inst.element;
            this.instance.fromOutside = inst;
          }

          //Provided we did all the previous steps, we can fire the drag event of the sortable on every draggable drag, when it intersects with the sortable
          if (this.instance.currentItem) {
            this.instance._mouseDrag(event);
          }
        } else {
          //If it doesn't intersect with the sortable, and it intersected before,
          //we fake the drag stop of the sortable, but make sure it doesn't remove the helper by using cancelHelperRemoval
          if (this.instance.isOver) {
            this.instance.isOver = 0;
            this.instance.cancelHelperRemoval = true;

            //Prevent reverting on this forced stop
            this.instance.options.revert = false;

            // The out event needs to be triggered independently
            this.instance._trigger(
              'out',
              event,
              this.instance._uiHash(this.instance),
            );

            this.instance._mouseStop(event, true);
            this.instance.options.helper = this.instance.options._helper;

            //Now we remove our currentItem, the list group clone again, and the placeholder, and animate the helper back to it's original size
            this.instance.currentItem.remove();
            if (this.instance.placeholder) {
              this.instance.placeholder.remove();
            }

            inst._trigger('fromSortable', event);
            inst.dropped = false; //draggable revert needs that
          }
        }
      });
    },
  });

  $.ui.plugin.add('draggable', 'cursor', {
    start: function() {
      var t = $('body'),
        o = $(this).data('ui-draggable').options;
      if (t.css('cursor')) {
        o._cursor = t.css('cursor');
      }
      t.css('cursor', o.cursor);
    },
    stop: function() {
      var o = $(this).data('ui-draggable').options;
      if (o._cursor) {
        $('body').css('cursor', o._cursor);
      }
    },
  });

  $.ui.plugin.add('draggable', 'opacity', {
    start: function(event, ui) {
      var t = $(ui.helper),
        o = $(this).data('ui-draggable').options;
      if (t.css('opacity')) {
        o._opacity = t.css('opacity');
      }
      t.css('opacity', o.opacity);
    },
    stop: function(event, ui) {
      var o = $(this).data('ui-draggable').options;
      if (o._opacity) {
        $(ui.helper).css('opacity', o._opacity);
      }
    },
  });

  $.ui.plugin.add('draggable', 'scroll', {
    start: function() {
      var i = $(this).data('ui-draggable');
      if (
        i.scrollParent[0] !== document &&
        i.scrollParent[0].tagName !== 'HTML'
      ) {
        i.overflowOffset = i.scrollParent.offset();
      }
    },
    drag: function(event) {
      var i = $(this).data('ui-draggable'),
        o = i.options,
        scrolled = false;

      if (
        i.scrollParent[0] !== document &&
        i.scrollParent[0].tagName !== 'HTML'
      ) {
        if (!o.axis || o.axis !== 'x') {
          if (
            i.overflowOffset.top +
              i.scrollParent[0].offsetHeight -
              event.pageY <
            o.scrollSensitivity
          ) {
            i.scrollParent[0].scrollTop = scrolled =
              i.scrollParent[0].scrollTop + o.scrollSpeed;
          } else if (event.pageY - i.overflowOffset.top < o.scrollSensitivity) {
            i.scrollParent[0].scrollTop = scrolled =
              i.scrollParent[0].scrollTop - o.scrollSpeed;
          }
        }

        if (!o.axis || o.axis !== 'y') {
          if (
            i.overflowOffset.left +
              i.scrollParent[0].offsetWidth -
              event.pageX <
            o.scrollSensitivity
          ) {
            i.scrollParent[0].scrollLeft = scrolled =
              i.scrollParent[0].scrollLeft + o.scrollSpeed;
          } else if (
            event.pageX - i.overflowOffset.left <
            o.scrollSensitivity
          ) {
            i.scrollParent[0].scrollLeft = scrolled =
              i.scrollParent[0].scrollLeft - o.scrollSpeed;
          }
        }
      } else {
        if (!o.axis || o.axis !== 'x') {
          if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
            scrolled = $(document).scrollTop(
              $(document).scrollTop() - o.scrollSpeed,
            );
          } else if (
            $(window).height() - (event.pageY - $(document).scrollTop()) <
            o.scrollSensitivity
          ) {
            scrolled = $(document).scrollTop(
              $(document).scrollTop() + o.scrollSpeed,
            );
          }
        }

        if (!o.axis || o.axis !== 'y') {
          if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
            scrolled = $(document).scrollLeft(
              $(document).scrollLeft() - o.scrollSpeed,
            );
          } else if (
            $(window).width() - (event.pageX - $(document).scrollLeft()) <
            o.scrollSensitivity
          ) {
            scrolled = $(document).scrollLeft(
              $(document).scrollLeft() + o.scrollSpeed,
            );
          }
        }
      }

      if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
        $.ui.ddmanager.prepareOffsets(i, event);
      }
    },
  });

  $.ui.plugin.add('draggable', 'snap', {
    start: function() {
      var i = $(this).data('ui-draggable'),
        o = i.options;

      i.snapElements = [];

      $(
        o.snap.constructor !== String
          ? o.snap.items || ':data(ui-draggable)'
          : o.snap,
      ).each(function() {
        var $t = $(this),
          $o = $t.offset();
        if (this !== i.element[0]) {
          i.snapElements.push({
            item: this,
            width: $t.outerWidth(),
            height: $t.outerHeight(),
            top: $o.top,
            left: $o.left,
          });
        }
      });
    },
    drag: function(event, ui) {
      var ts,
        bs,
        ls,
        rs,
        l,
        r,
        t,
        b,
        i,
        first,
        inst = $(this).data('ui-draggable'),
        o = inst.options,
        d = o.snapTolerance,
        x1 = ui.offset.left,
        x2 = x1 + inst.helperProportions.width,
        y1 = ui.offset.top,
        y2 = y1 + inst.helperProportions.height;

      for (i = inst.snapElements.length - 1; i >= 0; i--) {
        l = inst.snapElements[i].left;
        r = l + inst.snapElements[i].width;
        t = inst.snapElements[i].top;
        b = t + inst.snapElements[i].height;

        if (
          x2 < l - d ||
          x1 > r + d ||
          y2 < t - d ||
          y1 > b + d ||
          !$.contains(
            inst.snapElements[i].item.ownerDocument,
            inst.snapElements[i].item,
          )
        ) {
          if (inst.snapElements[i].snapping) {
            inst.options.snap.release &&
              inst.options.snap.release.call(
                inst.element,
                event,
                $.extend(inst._uiHash(), {
                  snapItem: inst.snapElements[i].item,
                }),
              );
          }
          inst.snapElements[i].snapping = false;
          continue;
        }

        if (o.snapMode !== 'inner') {
          ts = Math.abs(t - y2) <= d;
          bs = Math.abs(b - y1) <= d;
          ls = Math.abs(l - x2) <= d;
          rs = Math.abs(r - x1) <= d;
          if (ts) {
            ui.position.top =
              inst._convertPositionTo('relative', {
                top: t - inst.helperProportions.height,
                left: 0,
              }).top - inst.margins.top;
          }
          if (bs) {
            ui.position.top =
              inst._convertPositionTo('relative', { top: b, left: 0 }).top -
              inst.margins.top;
          }
          if (ls) {
            ui.position.left =
              inst._convertPositionTo('relative', {
                top: 0,
                left: l - inst.helperProportions.width,
              }).left - inst.margins.left;
          }
          if (rs) {
            ui.position.left =
              inst._convertPositionTo('relative', { top: 0, left: r }).left -
              inst.margins.left;
          }
        }

        first = ts || bs || ls || rs;

        if (o.snapMode !== 'outer') {
          ts = Math.abs(t - y1) <= d;
          bs = Math.abs(b - y2) <= d;
          ls = Math.abs(l - x1) <= d;
          rs = Math.abs(r - x2) <= d;
          if (ts) {
            ui.position.top =
              inst._convertPositionTo('relative', { top: t, left: 0 }).top -
              inst.margins.top;
          }
          if (bs) {
            ui.position.top =
              inst._convertPositionTo('relative', {
                top: b - inst.helperProportions.height,
                left: 0,
              }).top - inst.margins.top;
          }
          if (ls) {
            ui.position.left =
              inst._convertPositionTo('relative', { top: 0, left: l }).left -
              inst.margins.left;
          }
          if (rs) {
            ui.position.left =
              inst._convertPositionTo('relative', {
                top: 0,
                left: r - inst.helperProportions.width,
              }).left - inst.margins.left;
          }
        }

        if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
          inst.options.snap.snap &&
            inst.options.snap.snap.call(
              inst.element,
              event,
              $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item }),
            );
        }
        inst.snapElements[i].snapping = ts || bs || ls || rs || first;
      }
    },
  });

  $.ui.plugin.add('draggable', 'stack', {
    start: function() {
      var min,
        o = this.data('ui-draggable').options,
        group = $.makeArray($(o.stack)).sort(function(a, b) {
          return (
            (parseInt($(a).css('zIndex'), 10) || 0) -
            (parseInt($(b).css('zIndex'), 10) || 0)
          );
        });

      if (!group.length) {
        return;
      }

      min = parseInt($(group[0]).css('zIndex'), 10) || 0;
      $(group).each(function(i) {
        $(this).css('zIndex', min + i);
      });
      this.css('zIndex', min + group.length);
    },
  });

  $.ui.plugin.add('draggable', 'zIndex', {
    start: function(event, ui) {
      var t = $(ui.helper),
        o = $(this).data('ui-draggable').options;
      if (t.css('zIndex')) {
        o._zIndex = t.css('zIndex');
      }
      t.css('zIndex', o.zIndex);
    },
    stop: function(event, ui) {
      var o = $(this).data('ui-draggable').options;
      if (o._zIndex) {
        $(ui.helper).css('zIndex', o._zIndex);
      }
    },
  });
})(jQuery);
